export const el = {
  lang: "el",
  path: "/el",
  meta: {
    title: "GetTaxcy - Ταξί & Μεταφορές Αεροδρομίου στην Κύπρο | Πάφος, Λάρνακα, Έρτζαν",
    description:
      "Το GetTaxcy είναι η εφαρμογή ταξί για την Κύπρο από την Costataxicy, Πάφος. Ταξί με σταθερές τιμές και μεταφορές από τα αεροδρόμια Λάρνακας, Πάφου και Έρτζαν, 24/7 σε όλο το νησί. Κράτηση στο WhatsApp +357 99940234.",
    locale: "el_GR",
  },
  switcher: { href: "/", label: "EN", aria: "English" },
  nav: [
    { href: "#services", label: "Διαδρομή" },
    { href: "#airport", label: "Αεροδρόμιο" },
    { href: "#business", label: "Επιχειρήσεις" },
    { href: "#faq", label: "Συχνές ερωτήσεις" },
  ],
  getApp: "Λήψη εφαρμογής",
  help: "Βοήθεια",
  bookWhatsapp: "Κράτηση στο WhatsApp",
  bookShort: "Κράτηση",
  homeAria: "Αρχική GetTaxcy",
  stores: {
    "google-play": { kicker: "Διαθέσιμο στο", label: "Google Play" },
    "app-store": { kicker: "Κατεβάστε από το", label: "App Store" },
    comingSoon: "Έρχεται σύντομα",
    comingSoonLine: "Η εφαρμογή έρχεται σύντομα στο Google Play και στο App Store.",
  },
  banner: {
    text: "Η εφαρμογή GetTaxcy έρχεται σύντομα στο Google Play και στο App Store –",
    link: "κάντε κράτηση τώρα στο WhatsApp",
  },
  hero: {
    location: "Πάφος · Όλη η Κύπρος",
    title: "Πηγαίνετε οπουδήποτε στην Κύπρο",
    text: "Ταξί με σταθερές τιμές και μεταφορές αεροδρομίου σε όλη την Κύπρο, 24/7.",
    whatsappLink: "Ή κάντε κράτηση στο WhatsApp",
    collage: {
      ready: "Έτοιμοι για ταξίδι;",
      airport: "Ταξιδιώτες με αποσκευές σε αεροδρόμιο",
      car: "Φωτισμένη πινακίδα ταξί τη νύχτα",
      town: "Φάρος της Πάφου, Κύπρος",
    },
    subtitle: "Ταξί με σταθερές τιμές και μεταφορές από τα αεροδρόμια Λάρνακας, Πάφου και Έρτζαν — για οποιονδήποτε προορισμό στο νησί, 24/7.",
    rideLink: "Χρειάζεστε ταξί σήμερα; Κράτηση στο WhatsApp",
    imgAlt: "Παραλιακός δρόμος στην Πάφο, Κύπρος",
    chipFixed: "Σταθερή τιμή, συμφωνημένη από πριν",
  },
  booking: {
    pickup: "Σημείο παραλαβής",
    pickupPh: "π.χ. Αεροδρόμιο Πάφου",
    dropoff: "Σημείο αποβίβασης",
    dropoffPh: "π.χ. Λεμεσός, όνομα ξενοδοχείου",
    date: "Ημερομηνία",
    time: "Ώρα",
    passengers: "Επιβάτες",
    submit: "Τιμή μέσω WhatsApp",
    error: "Συμπληρώστε σημείο παραλαβής και αποβίβασης.",
    asap: "Το συντομότερο δυνατό",
    msg: { intro: "Γεια σας GetTaxcy, θα ήθελα τιμή για μια διαδρομή.", pickup: "Παραλαβή", dropoff: "Αποβίβαση", when: "Ημερομηνία/ώρα", pax: "Επιβάτες" },
  },
  services: {
    title: "Ανακαλύψτε τι μπορείτε να κάνετε με το GetTaxcy",
    details: "Λεπτομέρειες",
    bookMsg: "Γεια σας GetTaxcy, θα ήθελα πληροφορίες για: ",
    items: [
      { id: "airport", title: "Μεταφορές αεροδρομίου", text: "Αεροδρόμια Λάρνακας, Πάφου και Έρτζαν, με υποδοχή στις αφίξεις." },
      { id: "long", title: "Διαδρομές μεγάλης απόστασης", text: "Διαδρομές με σταθερή τιμή ανάμεσα σε οποιεσδήποτε πόλεις της Κύπρου." },
      { id: "minibus", title: "Μίνι λεωφορεία 6–9 & 12+", text: "Οχήματα 6–9 θέσεων και μίνι λεωφορεία 12+ θέσεων για οικογένειες και γκρουπ." },
      { id: "north", title: "Βόρεια Κύπρος", text: "Διαδρομές από και προς τη Βόρεια Κύπρο. Τιμή κατόπιν αιτήματος." },
      { id: "business", title: "Εταιρικοί λογαριασμοί", text: "Τακτικές διαδρομές για την εταιρεία, το προσωπικό και τους επισκέπτες σας. Επικοινωνήστε μαζί μας για να ανοίξετε λογαριασμό." },
    ],
  },
  marqueeAria: "Προορισμοί που εξυπηρετούμε",
  marquee: ["Αεροδρόμιο Πάφου", "Αεροδρόμιο Λάρνακας", "Αεροδρόμιο Έρτζαν", "Λεμεσός", "Λευκωσία", "Αγία Νάπα", "Τρόοδος", "Μεγάλες αποστάσεις", "24/7 σε όλη την Κύπρο"],
  how: {
    title: "Πώς να ζητήσετε διαδρομή",
    appSteps: [
      { title: "Κατεβάστε την εφαρμογή", text: "Εγκαταστήστε το GetTaxcy από το Google Play ή το App Store." },
      { title: "Ορίστε παραλαβή και προορισμό", text: "Δείτε τη σταθερή τιμή πριν επιβεβαιώσετε τη διαδρομή." },
      { title: "Ο οδηγός σας φτάνει", text: "Παρακολουθήστε τον αδειούχο οδηγό σας ζωντανά μέχρι να φτάσει." },
    ],
    text: "Κάντε κράτηση, δείτε τον οδηγό σας ζωντανά και ταξιδέψτε. Χωρίς παζάρια, χωρίς εκπλήξεις — πίσω από κάθε διαδρομή βρίσκεται μια αδειούχα εταιρεία ταξί της Πάφου.",
    steps: [
      { n: "01", title: "Κράτηση", text: "Δηλώστε σημείο παραλαβής και προορισμό και επιβεβαιώστε τη σταθερή τιμή πριν ξεκινήσετε." },
      { n: "02", title: "Δείτε τον οδηγό σας", text: "Παρακολουθήστε τον αδειούχο οδηγό σας καθώς έρχεται. Στο αεροδρόμιο σας περιμένει στις αφίξεις με πινακίδα με το όνομά σας." },
      { n: "03", title: "Διαδρομή", text: "Χαλαρώστε σε ένα καθαρό σεντάν, όχημα 6–9 θέσεων ή μίνι λεωφορείο, οπουδήποτε στην Κύπρο." },
    ],
  },
  why: {
    eyebrow: "Γιατί GetTaxcy",
    title: "Μια τοπική εταιρεία ταξί,",
    titleAccent: "στην τσέπη σας.",
    price: { title: "Σταθερές τιμές", text: "Η τιμή συμφωνείται πριν από τη διαδρομή. Ό,τι βλέπετε, αυτό πληρώνετε." },
    greet: {
      sign: "Το όνομά σας",
      title: "Υποδοχή στο αεροδρόμιο",
      text: "Στη Λάρνακα, την Πάφο και το Έρτζαν, ο οδηγός σας περιμένει στις αφίξεις κρατώντας πινακίδα με το όνομά σας.",
      alt: "Οδηγός GetTaxcy με πινακίδα ονόματος στις αφίξεις του αεροδρομίου",
    },
    clock: { title: "Μέρα ή νύχτα", text: "Πρωινές πτήσεις, αργές αφίξεις — οδηγούμε όλο το 24ωρο." },
    island: {
      title: "Όλη η Κύπρος",
      text: "Από σύντομες διαδρομές στην πόλη μέχρι μεγάλες αποστάσεις από ακτή σε ακτή.",
      places: ["Πάφος", "Λεμεσός", "Λάρνακα", "Λευκωσία", "Αγία Νάπα", "Έρτζαν", "Πόλις", "Τρόοδος"],
    },
    fleet: {
      title: "Όχημα για κάθε παρέα",
      items: [
        { name: "Σεντάν", seats: "1–4" },
        { name: "Οχήματα 6–9 θέσεων", seats: "6–9" },
        { name: "Μίνι λεωφορεία", seats: "Γκρουπ" },
      ],
    },
  },
  ride: {
    kicker: "Δεν μπορείτε να περιμένετε την εφαρμογή;",
    title1: "Χρειάζεστε",
    title2: "ταξί τώρα;",
    text: "Στείλτε μήνυμα ή καλέστε την Costataxicy και θα σας επιβεβαιώσουμε αμέσως οδηγό και σταθερή τιμή.",
    whatsapp: "Κράτηση στο WhatsApp",
    call: "Κλήση τώρα",
    website: "Επισκεφθείτε την κεντρική μας ιστοσελίδα costataxicy.com",
  },
  faq: {
    eyebrow: "Συχνές ερωτήσεις",
    title: "Καλό να ξέρετε.",
    items: [
      {
        q: "Πώς υπολογίζονται οι τιμές;",
        a: "Κάθε διαδρομή GetTaxcy έχει σταθερή τιμή που συμφωνείται πριν ταξιδέψετε, οπότε πληρώνετε ακριβώς ό,τι βλέπετε. Στείλτε μας σημείο παραλαβής και προορισμό στο WhatsApp ή καλέστε μας για προσφορά.",
      },
      {
        q: "Πώς γίνεται η παραλαβή από το αεροδρόμιο;",
        a: "Παραλαμβάνουμε από τα αεροδρόμια Λάρνακας, Πάφου και Έρτζαν. Ο οδηγός σας σας υποδέχεται στον χώρο αφίξεων με πινακίδα με το όνομά σας και σας συνοδεύει ως το αυτοκίνητο.",
      },
      { q: "Πώς μπορώ να πληρώσω;", a: "Δεχόμαστε μετρητά και κάρτα. Η τιμή σας είναι σταθερή και συμφωνείται κατά την κράτηση, χωρίς εκπλήξεις στο τέλος της διαδρομής." },
      {
        q: "Πότε θα είναι διαθέσιμη η εφαρμογή GetTaxcy;",
        a: "Η εφαρμογή GetTaxcy έρχεται σύντομα στο Google Play και στο App Store. Μέχρι τότε, κάντε κράτηση αμέσως στο WhatsApp ή τηλεφωνικά στο +357 99940234.",
      },
      {
        q: "Μπορώ να κλείσω μεγάλο όχημα ή διαδρομή μεγάλης απόστασης;",
        a: "Ναι. Επιλέξτε ανάμεσα σε σεντάν, οχήματα 6–9 θέσεων και μίνι λεωφορεία, για σύντομες διαδρομές στην πόλη ή μεγάλες αποστάσεις οπουδήποτε στην Κύπρο.",
      },
    ],
  },
  footer: {
    about: "Το GetTaxcy λειτουργεί από την Costataxicy, αδειούχα εταιρεία ταξί στην Πάφο που εξυπηρετεί όλη την Κύπρο.",
    company: "Εταιρεία",
    address1: "Διαγόρου 20",
    address2: "Πάφος 8042, Κύπρος",
    phone: "Τηλέφωνο / WhatsApp",
    chat: "Συνομιλία στο WhatsApp",
    email: "Email",
    rights: "Με επιφύλαξη παντός δικαιώματος.",
  },
};
